/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import SpeedTestContainer from '@scenes/SpeedTestPage';

/* Constants */
import { PAGE_TYPE_SPEED } from '@constants/pages';

/* Types */
import { Children } from 'types/base.types';

function SpeedTest(): Children {
  return <SpeedTestContainer />;
}

SpeedTest.pageAttributes = { page: PAGE_TYPE_SPEED };
SpeedTest.Layout = getLayout({ promo: true, footer: true });

export default SpeedTest;
